module.exports = __webpack_public_path__ + "static/media/5.0cea92e3.jpg";